module.exports = __webpack_public_path__ + "img/one-time-new.3298ca6e.svg";